import { RouteObject } from "react-router-dom";
import { GoogleAuth } from "./google-auth";

/**
 * Routes for authentication
 */
export const authRoutes: RouteObject[] = [
  { path: "google-auth", element: <GoogleAuth /> },
];
